import axios from "axios";

// @ts-ignore
import CryptoJS from "crypto-js";
export function getSignature(
  apps: string,
  nonce: string,
  timestamp: string
): string {
  const ret = CryptoJS.SHA1(apps + nonce + timestamp);
  return ret.toString();
}
export const appSecret = "wst";

export async function getToken(userId: number, url?: string) {
  const Nonce = `${Math.random()}`;
  const Timestamp = `${Date.now()}`;
  const Signature = getSignature(appSecret, Nonce, Timestamp);
  const res = await axios({
    url: url || "/user/getToken.json",
    method: "post",
    headers: {
      Nonce,
      Timestamp,
      Signature
    },
    params: {
      userId
    }
  });
  return res.data.token;
}
